import React, { Component } from 'react';

import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Tabs, { tabsClasses } from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Pagination from '@mui/material/Pagination';
import ToggleButton from '@mui/material/ToggleButton';
import {
    DataGrid,
    useGridApiContext,
    useGridState,
    GridToolbarContainer,
    GridToolbarColumnsButton,
    GridToolbarFilterButton,
    GridToolbarDensitySelector,
} from '@mui/x-data-grid';

import PauseIcon from '@mui/icons-material/Pause';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import AddAlertIcon from '@mui/icons-material/AddAlert';
import HelpIcon from '@mui/icons-material/Help';
import MenuIcon from '@mui/icons-material/MoreVert';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';

import { createTheme, ThemeProvider } from '@mui/material/styles';

import { getJson } from '../../helpers/RequestsHelper';
import ContactFormTools from '../../components/ContactFormTools';
import { Typography } from '@mui/material';
import Tooltip from '@mui/material/Tooltip';
import Modal from '@mui/material/Modal';
import Popover from '@mui/material/Popover';
import AuthFlow from '../../components/AuthFlow';

const theme = createTheme({
    palette: {
        primary: {
            main: '#d01a62',
        },
    },
    typography: {
        fontFamily: '"Poppins", sans-serif',
        fontSize: 16
    }
})

const columnLayout = [
    {
        field: 'symbol', headerName: 'Symbol', padding: 0, width: 110, sortable: false, hideSortIcons: true, renderCell: (params) => (
            <strong>
                <a target="new" href={"https://www.binance.us/en/trade/pro/" + params.value}>{params.value}</a>
            </strong>
        )
    },
    { field: 'activity', headerName: 'Activity', width: 110, sortable: false, hideSortIcons: true, hide: true },
    { field: 'recentActivity', headerName: 'Recent Activity', width: 110, sortable: false, hideSortIcons: true, },
    { field: 'sum', headerName: 'Sum', width: 110, sortable: false },
    { field: 'percentageChangeSum', headerName: 'Sum %', width: 110, sortable: false, hideSortIcons: true, hide: true },
    { field: 'mean', headerName: 'Mean', width: 110, sortable: false },
    { field: 'percentageChangeMean', headerName: 'Mean %', width: 110, sortable: false, hideSortIcons: true },
    { field: 'value', headerName: 'Value', width: 110, sortable: false },
    { field: 'percentageChangeValue', headerName: 'Value %', width: 110, sortable: false, hideSortIcons: true, hide: true },

    { field: 'variance', headerName: 'Variance', width: 110, sortable: false, hide: true, hideSortIcons: true },
    { field: 'standardDeviation', headerName: 'SD', width: 110, sortable: false, hideSortIcons: true },
    { field: 'standardDeviationToMeanRatio', headerName: 'SD % Mean', width: 110, sortable: false, hideSortIcons: true },
    { field: 'valueDeviationDegree', headerName: 'SD °', width: 110, sortable: false, hideSortIcons: true, hide: true },

    { field: 'valueDeviationFromMean', headerName: 'Value Δ Mean', width: 110, sortable: false, hideSortIcons: true }
]

class DataGridInterface {
    constructor(columns, rows, gridDataLoaded, currentSortedModel) {
        this.columns = columns ? columns : []
        this.rows = rows ? rows : []
        this.gridDataLoaded = gridDataLoaded ? gridDataLoaded : false
        this.currentSortedModel = currentSortedModel ? currentSortedModel : undefined
    }
}

class DataGridRowInterface {
    constructor(args) {
        const keys = Object.keys(args)
        for (let i = 0; i < keys.length; i++) {
            var key = keys[i]
            var value = args[key]
            this[key] = value
        }
    }
}

function CustomPaginationComponent(props) {
    const apiRef = useGridApiContext()
    const [state] = useGridState(apiRef)
    return (
        state.pagination.pageCount === 1 ? null :
            <Pagination
                color="primary"
                size="small"

                sx={{
                    color: "#d01a62",
                    '.MuiPaginationItem-previousNext': { width: 18, height: 18, color: '#d01a62', opacity: 1 },
                    '.Mui-disabled': { color: 'black', opacity: 0.3 }
                }}
                siblingCount={window.screen.width < 992 ? 0 : 2}
                boundaryCount={window.screen.width < 992 ? 0 : 1}
                // showFirstButton={state.pagination.page < 1? false : true}
                // showLastButton={state.pagination.page + 1 < state.pagination.pageCount? true : false}
                count={state.pagination.pageCount}
                page={state.pagination.page + 1}
                onChange={(event, value) => apiRef.current.setPage(value - 1)}
            />
    )
}

function MinimalFooterComponent(props) {
    const apiRef = useGridApiContext()
    const [state] = useGridState(apiRef)
    return (
        state.pagination.pageCount === 1 ? null :
            <Box sx={{ display: 'flex', flexDirection: 'row', alignContent: 'center', alignItems: 'center', justifyContent: 'flex-end', minHeight: '60px' }}>
                <CustomPaginationComponent />
            </Box>
    )
}

function CustomFooterComponent(props) {
    return (
        <Box sx={{ display: 'flex', flexDirection: 'row', alignContent: 'center', alignItems: 'center', justifyContent: 'flex-end', minHeight: '60px' }}>
            <ToggleButton
                size="small"
                width="24px"
                style={{ margin: '8px' }}
                value="displayHelp"
                selected={props.displayHelp}
                onChange={props.toggleHelp}
            >
                {props.displayHelp ? <HelpIcon sx={{ width: 18, height: 18 }} /> : <HelpIcon sx={{ width: 18, height: 18, color: '#d01a62' }} />}
            </ToggleButton>
            <ToggleButton
                size="small"
                width="24px"
                style={{ margin: '8px' }}
                value="refreshing"
                selected={props.refreshing}
                onChange={props.toggleRefresh}
            >
                {props.refreshing ? <PauseIcon sx={{ width: 18, height: 18 }} /> : <PlayArrowIcon sx={{ width: 18, height: 18, color: '#d01a62' }} />}
            </ToggleButton>
            <p style={{
                alignSelf: 'flex-start',
                flex: 1,
                margin: 'auto',
                paddingLeft: '16px',
                textAlign: 'left',
                fontSize: 16,
            }}>{props.refreshing ? (window.screen.width < 992 ? "" : "Refreshing in... ") + props.timer : (window.screen.width < 992 ? "" : props.pausedAt)}</p>
            <CustomPaginationComponent />
        </Box>
    )
}

function CustomToolbar() {
    return (
        <GridToolbarContainer>
            <GridToolbarColumnsButton sx={{ textTransform: 'none', fontSize: 16 }} />
            <GridToolbarFilterButton sx={{ textTransform: 'none', fontSize: 16 }} />
            <GridToolbarDensitySelector sx={{ textTransform: 'none', fontSize: 16 }} />
            {/* <GridToolbarExport /> */}
        </GridToolbarContainer>
    )
}

function CustomMinimalToolbar() {
    return (
        <GridToolbarContainer>
            <GridToolbarColumnsButton sx={{ textTransform: 'none', fontSize: 16 }} />
        </GridToolbarContainer>
    )
}

class CryptoActivityTrackerTool extends Component {

    state = {
        canContact: false,
        email: "",
        name: "",
        id: 1,
        localId: "",
        pausedAt: undefined,

        selectionModel: undefined,
        viewableGrid: "usdNetVolume",
        refreshing: true,
        displayHelp: false,
        timer: 0,

        columnMenuRef: undefined,
        columnMenuOpen: false,
        menuColumn: undefined,
        menuHighlightedGrid: false,
        signupModalOpen: false,

        alertData: undefined,

        grids: [
            { tag: "usdNetVolume", name: "USD Net Volume" },
            { tag: "usdTotalVolume", name: "USD Total Volume" },
            { tag: "usdBuyVolume", name: "USD Buy Volume" },
            { tag: "usdSellVolume", name: "USD Sell Volume" },
            { tag: "trades", name: "Trades" },
            { tag: "openPrice", name: "Open Price" },
            { tag: "closePrice", name: "Close Price" },
            { tag: "averagePrice", name: "Average Price" },
        ]
    }

    constructor() {
        super()

        this.highlightedGrid = new DataGridInterface()
        this.trades = new DataGridInterface()
        this.usdTotalVolume = new DataGridInterface()
        this.usdNetVolume = new DataGridInterface()
        this.usdBuyVolume = new DataGridInterface()
        this.usdSellVolume = new DataGridInterface()
        this.openPrice = new DataGridInterface()
        this.closePrice = new DataGridInterface()
        this.averagePrice = new DataGridInterface()

        this.manageLocalId = this.manageLocalId.bind(this)
        this.tickTock = this.tickTock.bind(this)
        this.setSortingModel = this.setSortingModel.bind(this)
        this.setVisibleGrid = this.setVisibleGrid.bind(this)
        this.toggleRefresh = this.toggleRefresh.bind(this)
        this.toggleHelp = this.toggleHelp.bind(this)
        this.setSelectionModel = this.setSelectionModel.bind(this)
        this.createHighlightedGrid = this.createHighlightedGrid.bind(this)
        this.sort = this.sort.bind(this)
        this.openColumnMenu = this.openColumnMenu.bind(this)
        this.closeColumnMenu = this.closeColumnMenu.bind(this)
        this.menuPopover = this.menuPopover.bind(this)
        this.createAlert = this.createAlert.bind(this)
        this.redirectAuthenticated = this.redirectAuthenticated.bind(this)
        this.closeModal = this.closeModal.bind(this)
        this.popoverOnClick = this.popoverOnClick.bind(this)

        this.tickTock()
    }

    componentDidMount() {
        this.manageLocalId()
    }

    manageLocalId() {
        let localId = localStorage.getItem("localId");
        if (!localId) {
            const uint32 = window.crypto.getRandomValues(new Uint32Array(1))[0];
            localId = uint32.toString(16)
            localStorage.setItem("localId", localId);
        }
        this.setState({ localId })
    }

    scrollTo(element) {
        element.scrollIntoView({ behavior: 'smooth' })
    }

    async tickTock() {
        if (this.state.timer === 0) {
            if (this.state.refreshing) {
                await this.getGridData()
                this.setState({ timer: 60 })
                await setTimeout(this.tickTock, 1000)
            } else {
                await setTimeout(this.tickTock, 1000)
            }
        } else {
            this.setState({ timer: this.state.timer - 1 })
            await setTimeout(this.tickTock, 1000)
        }
    }

    functionalTimestamp(time) {
        var options = { timeZone: 'America/New_York', hour12: false }
        let timeToFormat = Date.now()
        if (time) {
            timeToFormat = time
        }
        return new Date(timeToFormat).toLocaleTimeString('en-US', options)
    }

    toggleRefresh() {
        this.setState({ timer: 0, refreshing: !this.state.refreshing, pausedAt: this.functionalTimestamp(Date.now()) })
    }

    sort(field) {
        // if(this[this.state.viewableGrid].currentSortedModel.length === 0) {
        //     this[this.state.viewableGrid].currentSortedModel = [ { field, sort: 'null' } ]
        // }
        // let sortingOrder = ['asc', 'desc']
        // let currentSort = this[this.state.viewableGrid].currentSortedModel[0].sort
        // let currentField = this[this.state.viewableGrid].currentSortedModel[0].field
        // let currentSortOrder = sortingOrder.indexOf(currentSort)
        // let newSortingModel = [ { field, sort: sortingOrder[0] } ]
        // if(currentField === field) {
        //     newSortingModel[0].sort = sortingOrder[ (currentSortOrder + 1) % 2 ]
        // } 
        // this[this.state.viewableGrid].currentSortedModel = newSortingModel
        // this.setState({})
    }

    sortByOrder(field, sort) {
        if (this.state.menuHighlightedGrid === "highlightedGrid") {
            this.highlightedGrid[this.state.viewableGrid].currentSortedModel = [{ field, sort }]
        } else {
            this[this.state.viewableGrid].currentSortedModel = [{ field, sort }]
        }
        this.setState({})
    }

    toggleHelp() {
        this.setState({ displayHelp: !this.state.displayHelp })
    }

    getDataViewColumnLayout(highlightedGrid) {
        let columnsLayout = columnLayout

        for (let i = 0; i < columnsLayout.length; i++) {
            let column = columnsLayout[i]
            let element = this.createCustomHeader(column, highlightedGrid)
            column.renderHeader = () => (element)

        }

        return columnsLayout
    }

    async getGridData() {
        let url = process.env.REACT_APP_SERVER_BASE_URL + '/screener/getTick'
        let json = await getJson(url)
            .catch((e) => { console.log(e) })

        if (json && !json.error) {
            this.processGridData(json)
        }
    }

    processGridData(gridData) {
        let keys = Object.keys(gridData)
        let columns = this.getDataViewColumnLayout()
        let rows = {
            usdTotalVolume: [],
            usdNetVolume: [],
            usdBuyVolume: [],
            usdSellVolume: [],
            trades: [],
            openPrice: [],
            closePrice: [],
            averagePrice: []
        }
        for (let i = 0; i < keys.length; i++) {
            const key = keys[i]
            const symbol = key
            const symbolData = gridData[key]

            rows.usdTotalVolume.push(new DataGridRowInterface({ symbol, id: symbol, ...symbolData.usdTotalVolume }))
            rows.usdNetVolume.push(new DataGridRowInterface({ symbol, id: symbol, ...symbolData.usdNetVolume }))
            rows.usdBuyVolume.push(new DataGridRowInterface({ symbol, id: symbol, ...symbolData.usdBuyVolume }))
            rows.usdSellVolume.push(new DataGridRowInterface({ symbol, id: symbol, ...symbolData.usdSellVolume }))
            rows.trades.push(new DataGridRowInterface({ symbol, id: symbol, ...symbolData.trades }))
            rows.openPrice.push(new DataGridRowInterface({ symbol, id: symbol, ...symbolData.openPrice }))
            rows.closePrice.push(new DataGridRowInterface({ symbol, id: symbol, ...symbolData.closePrice }))
            rows.averagePrice.push(new DataGridRowInterface({ symbol, id: symbol, ...symbolData.averagePrice }))
        }

        this.trades = new DataGridInterface(columns, rows.trades, true, this.trades.currentSortedModel ? this.trades.currentSortedModel : [{ field: "recentActivity", sort: 'desc' }])
        this.usdTotalVolume = new DataGridInterface(columns, rows.usdTotalVolume, true, this.usdTotalVolume.currentSortedModel ? this.usdTotalVolume.currentSortedModel : [{ field: "recentActivity", sort: 'desc' }])
        this.usdNetVolume = new DataGridInterface(columns, rows.usdNetVolume, true, this.usdNetVolume.currentSortedModel ? this.usdNetVolume.currentSortedModel : [{ field: "recentActivity", sort: 'desc' }])
        this.usdBuyVolume = new DataGridInterface(columns, rows.usdBuyVolume, true, this.usdBuyVolume.currentSortedModel ? this.usdBuyVolume.currentSortedModel : [{ field: "recentActivity", sort: 'desc' }])
        this.usdSellVolume = new DataGridInterface(columns, rows.usdSellVolume, true, this.usdSellVolume.currentSortedModel ? this.usdSellVolume.currentSortedModel : [{ field: "recentActivity", sort: 'desc' }])
        this.openPrice = new DataGridInterface(columns, rows.openPrice, true, this.openPrice.currentSortedModel ? this.openPrice.currentSortedModel : [{ field: "recentActivity", sort: 'desc' }])
        this.closePrice = new DataGridInterface(columns, rows.closePrice, true, this.closePrice.currentSortedModel ? this.closePrice.currentSortedModel : [{ field: "recentActivity", sort: 'desc' }])
        this.averagePrice = new DataGridInterface(columns, rows.averagePrice, true, this.averagePrice.currentSortedModel ? this.averagePrice.currentSortedModel : [{ field: "recentActivity", sort: 'desc' }])
    }

    createHighlightedGrid(selectionModel) {
        let columns = this.getDataViewColumnLayout("highlightedGrid")

        for (let i = 0; i < this.state.grids.length; i++) {
            let gridTag = this.state.grids[i].tag
            let gridRef = this[gridTag]
            let rows = []
            let currentSortModel = [{ field: "recentActivity", sort: 'desc' }]
            for (let j = 0; j < gridRef.rows.length; j++) {
                let row = gridRef.rows[j]
                if (selectionModel.includes(row.id)) {
                    rows.push(row)
                }
            }

            if (this.highlightedGrid[gridTag] === undefined) {
                this.highlightedGrid[gridTag] = new DataGridInterface(columns, rows, true, currentSortModel)
            } else {
                if (this.highlightedGrid[gridTag].currentSortedModel != undefined) {
                    currentSortModel = this.highlightedGrid[gridTag].currentSortedModel
                }
                this.highlightedGrid[gridTag].rows = rows
            }
        }

        this.setState({})
    }

    setVisibleGrid(event, newValue) {
        this.setState({ viewableGrid: newValue })
    }

    setSelectionModel(selectionModel) {
        this.createHighlightedGrid(selectionModel)
        this.setState({ selectionModel })
    }

    setSortingModel(gridTag, model) {
        if (gridTag === "highlightedGrid") {
            if (!this[gridTag][this.state.viewableGrid].currentSortedModel) {
                this[gridTag][this.state.viewableGrid].currentSortedModel = [{ field: "recentActivity", sort: 'desc' }]
            }
            this[gridTag][this.state.viewableGrid].currentSortedModel = model
        } else {
            this[gridTag].currentSortedModel = model
        }
        this.setState({})
    }

    render() {
        return (
            <ThemeProvider theme={theme}>
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        height: '100%',
                        width: '-webkit-fill-available'
                    }}
                    ref={el => { this.elTop = el; }}
                >
                    <br />
                    {this.headerView()}
                    <Paper sx={{ display: 'flex', flex: 1, flexDirection: 'column', height: '100%', padding: '8px' }} elevation={2}>
                        {this.optionBarView()}
                        {this[this.state.viewableGrid].gridDataLoaded && this.state.selectionModel && this.state.selectionModel.length > 0 ? this.highlightedView() : null}
                        {this[this.state.viewableGrid].gridDataLoaded ? this.dataView() : null}
                    </Paper>
                    <br />
                    {this.state.displayHelp ? this.helpView() : null}
                    <ContactFormTools />
                </Box>

                {this.menuPopover()}
                {this.modalView()}
            </ThemeProvider>
        )
    }

    modalView() {
        return (
            <AuthFlow
                modalopen={this.state.signupModalOpen}
                props={{
                    title: "Let's set up my alert for..",
                    subtitle: this.state.alertData ? [this.state.alertData.viewableGridName, this.state.alertData.fieldName].join(" - ") : "",
                    data: this.state.alertData,
                    quickSignup: true,
                    modal: true,
                    modalOpen: this.state.signupModalOpen,
                    closeModal: this.closeModal,
                    onAuthenticated: this.redirectAuthenticated
                }}
            />
        )
    }

    closeModal() {
        this.setState({ signupModalOpen: false })
    }

    spacer(width, height, opacity, solid) {
        return (
            <div style={{ width, height, opacity, background: solid ? "gray" : "transparent" }}></div>
        )
    }

    headerView() {
        return (
            <div style={{ display: 'flex', paddingLeft: '8px', flexDirection: window.screen.width < 992 ? 'column' : 'row' }}>
                <br />
                <br />
                <h2 style={{ alignSelf: 'flex-start', flex: 1, width: '100%', fontSize: window.screen.width < 992 ? '1.5rem' : '2rem', paddingBottom: 0 }}>
                    {"Crypto Activity Tracker"}
                </h2>
                {window.availableReward}
            </div>
        )
    }

    helpView() {
        const style = {
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: '80%',
            overflow: 'auto',
            maxHeight: '600px',
            bgcolor: 'background.paper',
            boxShadow: 24,
            p: 4,
        }
        return (
            <ThemeProvider theme={theme}>
                <Modal
                    open={this.state.displayHelp}
                    onClose={this.toggleHelp}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style}>
                        <div style={{ display: 'flex', flexDirection: 'column' }} ref={el => { this.elHelp = el; }} >
                            {this.topicView("Refresh", [
                                "This screener refreshes every 1 min and shows an alanysis of a ticker containing data for the last 1 hr",
                                "1 hr ticker updates every minute (as one value gets added, one gets removed from the beginning)",
                                "Results refresh automatically, while all sorting, filters, selections, hidden columns, etc.. will persist, unless the page is refreshed",
                                "Refresh can be paused displaying the time it was paused for manual data analysis purposes",
                                "(Premium feature: persist on account)"
                            ])}
                            {this.topicView("Volume", [
                                "Volume has all been calculated to USD matching the average current asset price"
                            ])}
                            {this.topicView("Grid Types", [
                                "Total Volume Grid: Based on the combined total value for buys and sells (50K in USD buys and 30K in USD sells = 80K total USD volume)",
                                "Net Volume Grid: Based on the combined net value for buys and sells (50K in USD buys and 30K in USD sells = 20K net USD volume)",
                                "Buy and Sell Volume Grid: Based on the total value for buys and sells respectively",
                                "Trade Grid: Based on the number of combined maker and taker sales on said asset"
                            ])}
                            {this.topicView("Symbol", [
                                "Clicking on the symbol will open the selected market on Binance.US in a new tab"
                            ])}
                            {this.topicView("Activity | Recent Activity", [
                                "Based on the value of the Standard Deviation degree, activity being the combined value over the last hour (min 60, max 180), and recent activity being the combined value over the last 3 minutes (min 1, max 9)"
                            ])}
                            {this.topicView("Sum, Mean, Variance, Standard Deviation (SD), Value", [
                                "Calculated for the ticker values over the past 1 hr, including the last value",
                                "Value is the last value for this grid (last 1 min)"
                            ])}
                            {this.topicView("Sum %, Mean %, Value %", [
                                "Percentage difference between caused between current value and previous value (the percent change betwen the sum 1 min ago vs the sum now, mean 1 min ago vs mean now, etc.)"
                            ])}
                            {this.topicView("SD % Mean", [
                                "The ratio between the standard deviation and mean price/volume/trades, accurate portrayal of movement for an asset"
                            ])}
                            {this.topicView("SD °", [
                                "1, 2, or 3 standard deviations away from the mean for the current value (always positive), 1 standard deviation away would mean that the data is currently moving within expected values (around the mean), 2 further away from the mean, 3 the furthest"
                            ])}
                            {this.topicView("Value Δ Mean", [
                                "The actual difference between the current value and the mean"
                            ])}
                        </div>
                    </Box>
                </Modal>
            </ThemeProvider>
        )
    }

    topicView(title, descriptionLines) {
        return (
            <div style={{ width: '100%', display: 'flex', flexDirection: 'column' }}>
                <h4>{title}</h4>
                {descriptionLines.map((line, index) => {
                    return <span key={index + "_title"} style={{ paddingLeft: '16px' }}>{line}</span>
                })}
                <br />
            </div>
        )
    }

    optionBarView() {
        return (
            <div>
                <Tabs
                    value={this.state.viewableGrid}
                    onChange={this.setVisibleGrid}
                    variant="scrollable"
                    scrollButtons
                    sx={{
                        color: "#d01a62",
                        [`& .${tabsClasses.scrollButtons}`]: {
                            '&.Mui-disabled': { color: 'black', opacity: 0.3 },
                        },
                    }}
                >
                    <Tab label="Trades" value="trades" key="trades" sx={{ textTransform: 'none' }} />
                    <Tab label="USD Net Volume" value="usdNetVolume" key="usdNetVolume" sx={{ textTransform: 'none' }} />
                    <Tab label="USD Total Volume" value="usdTotalVolume" key="usdTotalVolume" sx={{ textTransform: 'none' }} />
                    <Tab label="USD Buy Volume" value="usdBuyVolume" key="usdBuyVolume" sx={{ textTransform: 'none' }} />
                    <Tab label="USD Sell Volume" value="usdSellVolume" key="usdSellVolume" sx={{ textTransform: 'none' }} />
                    <Tab label="Average Price" value="averagePrice" key="averagePrice" sx={{ textTransform: 'none' }} />
                    <Tab label="Open Price" value="openPrice" key="openPrice" sx={{ textTransform: 'none' }} />
                    <Tab label="Close Price" value="closePrice" key="closePrice" sx={{ textTransform: 'none' }} />
                </Tabs>
            </div>
        )
    }

    highlightedView() {
        return (
            <div style={{ width: '100%', flex: 1, minHeight: '250px', marginBottom: '8px' }}>
                <DataGrid
                    // data
                    rows={this.highlightedGrid[this.state.viewableGrid].rows}
                    columns={this.highlightedGrid[this.state.viewableGrid].columns}

                    // custom components
                    components={{
                        Toolbar: CustomToolbar,
                        Footer: MinimalFooterComponent
                    }}

                    sx={{
                        toolbar: { sx: { maxHeight: '300px' } },
                        '.MuiSvgIcon-root': { color: '#d01a62', opacity: 1 }
                    }}

                    // settings
                    rowsPerPageOptions={[50]}
                    pagination
                    disableColumnMenu={true}
                    disableSelectionOnClick={true}
                    disableDensitySelector={window.screen.width < 992 ? true : false}

                    // defaults
                    pageSize={50}
                    density="compact"

                    ref={el => { this.highlight_grid = el }}

                    // behavior
                    onSortModelChange={(model) => this.setSortingModel("highlightedGrid", model)}
                    sortModel={
                        this.highlightedGrid[this.state.viewableGrid].currentSortedModel ?
                            this.highlightedGrid[this.state.viewableGrid].currentSortedModel :
                            [{ field: "recentActivity", sort: 'desc' }]
                    }
                />
            </div>
        )
    }

    dataView() {
        return (
            <div style={{ width: '100%', flex: 2, minHeight: '400px' }}>
                <DataGrid
                    // data
                    rows={this[this.state.viewableGrid].rows}
                    columns={this[this.state.viewableGrid].columns}

                    // custom components
                    components={{
                        Toolbar: CustomToolbar,
                        Footer: CustomFooterComponent,
                    }}

                    componentsProps={{
                        toolbar: { sx: { maxHeight: '300px' } },
                        footer: { pausedAt: this.state.pausedAt, refreshing: this.state.refreshing, timer: this.state.timer, toggleRefresh: this.toggleRefresh.bind(this), displayHelp: this.state.displayHelp, toggleHelp: this.toggleHelp.bind(this) },
                    }}

                    sx={{
                        '.MuiSvgIcon-root': { color: '#d01a62', opacity: 1 }
                    }}

                    // settings
                    rowsPerPageOptions={[50]}
                    checkboxSelection
                    pagination
                    disableColumnMenu={true}
                    disableSelectionOnClick={true}
                    disableDensitySelector={window.screen.width < 992 ? true : false}

                    // defaults
                    pageSize={50}
                    density="compact"

                    ref={el => { this.data_grid = el }}

                    // behavior
                    onSelectionModelChange={(selectionModel) => this.setSelectionModel(selectionModel)}
                    selectionModel={this.state.selectionModel}
                    onSortModelChange={(model) => this.setSortingModel(this.state.viewableGrid, model)}
                    sortModel={
                        this[this.state.viewableGrid].currentSortedModel ?
                            this[this.state.viewableGrid].currentSortedModel :
                            [{ field: "recentActivity", sort: 'desc' }]
                    }
                />
            </div>
        )
    }

    openColumnMenu(event, column, highlightedGrid) {
        let element = event.currentTarget
        this.setState({ columnMenuOpen: true, columnMenuRef: element, menuColumn: column, menuHighlightedGrid: highlightedGrid })
    }

    closeColumnMenu() {
        this.setState({ columnMenuOpen: false, columnMenuRef: null, menuColumn: undefined, menuHighlightedGrid: undefined })
    }

    createCustomHeader(column, highlightedGrid) {
        return (
            <Box sx={{ width: column.width - 32, display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                <Tooltip title={column.headerName}>
                    <Typography sx={{ width: column.width - 32, display: 'block', fontSize: 16 }} noWrap={true}>
                        {column.headerName}
                    </Typography>
                </Tooltip>
                <MenuIcon sx={{ width: 18, height: 18, color: theme.palette.primary.main, cursor: 'pointer' }}
                    // onMouseEnter={(event) => {
                    //     this.openColumnMenu(event, column, this[this.state.viewableGrid].currentSortedModel) 
                    // }}
                    onClick={(event) => {
                        this.openColumnMenu(event, column, highlightedGrid)
                    }}
                ></MenuIcon>
            </Box>
        )
    }

    createAlert(currentcolumn, currentsortedmodel) {
        let fieldTarget = currentcolumn.field
        let sort = "null"
        if (fieldTarget === currentsortedmodel[0].field) {
            sort = currentsortedmodel[0].sort
        }
        const cognitoUser = window.userPool.getCurrentUser()

        let viewableGridTag = this.state.viewableGrid
        let viewableGridName = undefined
        for (let i = 0; i < this.state.grids.length; i++) {
            let gridInfo = this.state.grids[i]
            if (gridInfo.tag === viewableGridTag) {
                viewableGridName = gridInfo.name
            }
        }

        let alertData = { fieldName: currentcolumn.headerName, field: fieldTarget, sort, viewableGridTag, viewableGridName }
        if (!cognitoUser) {
            let stateUpdate = { alertData, signupModalOpen: true }
            // console.log("CREATING ALERT NOT LOGGED IN", stateUpdate)
            this.setState(stateUpdate)
        } else {
            let stateUpdate = { alertData, signupModalOpen: false }
            // console.log("CREATING ALERT LOGGED IN", stateUpdate)
            this.setState(stateUpdate)
            this.redirectAuthenticated(this.state.viewableGrid, fieldTarget)
        }
    }

    redirectAuthenticated(viewableGrid, field) {
        this.closeModal()
        if (!viewableGrid) {
            viewableGrid = this.state.viewableGrid
        }
        if (!field) {
            field = this.state.alertData.field
        }
        let url =
            window.location.origin +
            "/workflow/template/screener_detectleader_sendemail?onboarding=template&tested=true&block_0_params=%7B%22fields%22%3A%7B%22field%22%3A%22%7B%7B"
            + viewableGrid + "." + field +
            "%3AScreener%3A%24ref%7D%7D%22%7D%7D&block_1_params=%7B%22subject%22%3A%20%22%7B%7Bsymbol%3AScreener%3Atext%7D%7D%20is%20the%20new%20leader%22%7D"

        // console.log("AURL", url)
        window.open(url, "_blank")
    }

    menuPopover() {
        return (
            <Popover
                key={"menu_popover_"}
                open={this.state.columnMenuOpen}
                anchorEl={this.state.columnMenuRef}
                onClose={this.closeColumnMenu}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
            >
                <Box key={"container_popover_"} sx={{ display: 'flex', flexDirection: 'column', padding: '8px', justifyContent: 'space-between', cursor: 'pointer' }}>
                    {this.state.menuColumn && this.state.menuColumn.field !== "symbol" ? 
                    <Box key={"alert_"} sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center' }} onClick={(input) => {
                        this.createAlert(this.state.menuColumn, this[this.state.viewableGrid].currentSortedModel)
                        this.closeColumnMenu()
                    }}>
                        <AddAlertIcon sx={{ width: 18, height: 18, color: theme.palette.primary.main }}></AddAlertIcon>
                        {this.spacer("4px", "0px")}
                        <Typography sx={{ padding: '4px', fontSize: 16 }}>
                            {"Create Alert"}
                        </Typography>
                    </Box>
                    :""}
                    <Box key={"desc_sort_"} sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center' }}
                        onClick={(input) => this.popoverOnClick("desc")
                        }>
                        <ArrowDownwardIcon sx={{ width: 18, height: 18, color: theme.palette.primary.main }}></ArrowDownwardIcon>
                        {this.spacer("4px", "0px")}
                        <Typography sx={{ padding: '4px', fontSize: 16 }}>
                            {"Sort DESC"}
                        </Typography>
                    </Box>
                    <Box key={"asc_sort_"} sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center' }}
                        onClick={(input) => this.popoverOnClick("asc")
                        }>
                        <ArrowUpwardIcon sx={{ width: 18, height: 18, color: theme.palette.primary.main }}></ArrowUpwardIcon>
                        {this.spacer("4px", "0px")}
                        <Typography sx={{ padding: '4px', fontSize: 16 }}>
                            {"Sort ASC"}
                        </Typography>
                    </Box>
                </Box>
            </Popover>
        )
    }

    popoverOnClick(sortDirection) {
        this.sortByOrder(this.state.menuColumn.field, sortDirection)
        this.closeColumnMenu()
    }

}

export default CryptoActivityTrackerTool;